export const NON_LAYOUT = ['ben', 'newspaper'];
